import React from 'react'
import PropTypes from 'prop-types'

/*
  Library: https://www.npmjs.com/package/react-spinners
  Examples: http://www.davidhu.io/react-spinners/
*/
import { PropagateLoader } from 'react-spinners'

import './styles.less'

class Loading extends React.Component {
  render() {
    const { show = false, style, color } = this.props
    const loadingClassName = show ? 'loading' : 'loadingClose'
    return (
      <div className={loadingClassName} style={style}>
        <PropagateLoader className='loading' color={color || '#36D7B7'} loading={show} />
      </div>
    )
  }
}

Loading.propTypes = {
  show: PropTypes.bool,
  style: PropTypes.object,
  color: PropTypes.string
}

export default Loading
